export var now = function now() {
  return Date.now ? Date.now() : +new Date();
};